var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAddUserFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Add_user",
    "data-name": "Icon-Add user",
    transform: "translate(-24 -333)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    transform: "translate(24 333)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "add-user",
    transform: "translate(26 336.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3174",
    "data-name": "Path 3174",
    d: "M22.468,20.011H20.9V18.447a.447.447,0,1,0-.894,0v1.564H18.447a.447.447,0,1,0,0,.894h1.564v1.564a.447.447,0,0,0,.894,0V20.9h1.564a.447.447,0,1,0,0-.894Z",
    transform: "translate(-5.915 -6.86)",
    fill: "#ba43b1",
    stroke: "#ba43b1",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3175",
    "data-name": "Path 3175",
    d: "M10.28,15.884H4.68a.547.547,0,0,1-.56-.532,6.021,6.021,0,0,1,6.16-5.857,4.429,4.429,0,0,0,4.461-3.659,4.273,4.273,0,0,0-3.183-4.714A4.572,4.572,0,0,0,6.2,3.455a4.159,4.159,0,0,0,1.676,5.37A6.961,6.961,0,0,0,3,15.352a1.64,1.64,0,0,0,1.68,1.6h5.6a.533.533,0,1,0,0-1.065ZM6.92,5.235a3.28,3.28,0,0,1,3.36-3.195,3.28,3.28,0,0,1,3.36,3.195A3.28,3.28,0,0,1,10.28,8.43,3.284,3.284,0,0,1,6.92,5.235Z",
    transform: "translate(0 0)",
    fill: "#ba43b1",
    stroke: "#ba43b1",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddUserFill);
export default __webpack_public_path__ + "static/media/Icon-add-user-fill.508e2ad8e56ec97e54d9351ae4a60b0e.svg";
export { ForwardRef as ReactComponent };